var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded && _vm.session)?_c('div',{staticClass:"game-responsive",class:{
        responsive_10x16: !_vm.isIgsGame && !_vm.isNeGame && !_vm.isIbGame && _vm.gameId !== 'aviator' && _vm.gameId !== 'jet',
        responsive_3x4: _vm.isIgsGame,
        responsive_9x16: _vm.isNeGame || _vm.isIbGame || _vm.gameId === 'aviator' || _vm.gameId === 'jet'
    }},[_c('redpipe-frame',{attrs:{"session":_vm.loaded ? _vm.session : null}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/game/game-redpipe.vue?vue&type=template&id=16a2531a
// module id = J9AJ
// module chunks = 0